import React from "react";

export default function FIBAFullCourt({
  lineColor,
  showChargingCircle = false,
  showKeyHashMarks = false,
}) {
  return (
    <>
      {/*SIDELINE*/}
      <rect
        strokeWidth="0.2"
        fill="none"
        stroke={lineColor}
        y="-24.605"
        x="0"
        height="49.21"
        width="91.86"
      />
      {/*BACKBOARD*/}
      <path strokeWidth="0.2" fill="none" stroke={lineColor} d="M 4 -3 L 4 3" />
      <path
        strokeWidth="0.2"
        fill="none"
        stroke={lineColor}
        d="M 87.86 -3 L 87.86 3"
      />
      {/*BASKET*/}
      <circle
        r="0.75"
        cy="0"
        cx="5.25"
        fill="none"
        strokeWidth="0.2"
        stroke={lineColor}
      />
      <circle
        r="0.75"
        cy="0"
        cx="86.61"
        fill="none"
        strokeWidth="0.2"
        stroke={lineColor}
      />
      {/*PAINTED AREA*/}
      <path
        strokeWidth="0.2"
        fill="none"
        stroke={lineColor}
        d="M 91.86 -8.038 L 72.86 -8.038 L 72.86 8.038 L 91.86 8.038"
      />
      <path
        strokeWidth="0.2"
        fill="none"
        stroke={lineColor}
        d="M 0 -8.038 L 19 -8.038 L 19 8.038 L 0 8.038"
      />
      {/*circle Free Throw*/}
      <path
        strokeWidth="0.2"
        fill="none"
        stroke={lineColor}
        d="M 19 5.8 A 5.8 5.8 0 0 0 19 -5.8"
      />
      <path
        strokeWidth="0.2"
        fill="none"
        strokeDasharray="1,1"
        stroke={lineColor}
        d="M 19 -5.8 A 5.8 5.8 0 0 0 19 5.8"
      />
      <path
        strokeWidth="0.2"
        fill="none"
        stroke={lineColor}
        d="M 72.86 -5.8 A 5.8 5.8 0 0 0 72.86 5.8"
      />
      <path
        strokeWidth="0.2"
        fill="none"
        strokeDasharray="1,1"
        stroke={lineColor}
        d="M 72.86 5.8 A 5.8 5.8 0 0 0 72.86 -5.8"
      />
      {/*Three Point Line*/}
      <path
        strokeWidth="0.2"
        fill="none"
        stroke={lineColor}
        d="M 0 -21.65 L 9.89 -21.65"
      />
      <path
        strokeWidth="0.2"
        fill="none"
        stroke={lineColor}
        d="M 0 21.65 L 9.89 21.65"
      />
      <path
        strokeWidth="0.2"
        fill="none"
        stroke={lineColor}
        d="M 91.86 -21.65 L 81.97 -21.65"
      />
      <path
        strokeWidth="0.2"
        fill="none"
        stroke={lineColor}
        d="M 91.86 21.65 L 81.97 21.65"
      />
      <path
        strokeWidth="0.2"
        fill="none"
        stroke={lineColor}
        d="M 9.89 21.65 A 22.15 22.15 0 0 0 9.89 -21.65"
      />

      <path
        strokeWidth="0.2"
        fill="none"
        stroke={lineColor}
        d="M 81.97 -21.65  A 22 22 0 0 0 81.97 21.65 "
      />

      <circle
        r="5.9"
        cy="0"
        cx="45.93"
        fill="none"
        strokeWidth="0.2"
        stroke={lineColor}
      />
      <path
        strokeWidth="0.2"
        fill="none"
        stroke={lineColor}
        d="M 45.93 -24.605  L 45.93 24.605 "
      />

      {showChargingCircle && (
        <>
          <path
            strokeWidth="0.2"
            fill="none"
            stroke={lineColor}
            d="M 5.25 4 A 4 4 0 0 0 5.25 -4"
          ></path>
          <path
            strokeWidth="0.2"
            fill="none"
            stroke={lineColor}
            d="M 86.61 -4 A 4 4 0 0 0 86.61 4"
          ></path>
        </>
      )}
      {showKeyHashMarks && (
        <g>
          <line
            x1="15.74"
            y1="-8"
            x2="15.74"
            y2="-8.5"
            stroke={lineColor}
            strokeWidth="0.2"
          />
          <line
            x1="12.8"
            y1="-8"
            x2="12.8"
            y2="-8.5"
            stroke={lineColor}
            strokeWidth="0.2"
          />
          <line
            x1="10"
            y1="-8"
            x2="10"
            y2="-8.5"
            stroke={lineColor}
            strokeWidth="0.2"
          />
          <rect x="8.66" y="-8.5" width="1.31" height="0.5" fill={lineColor} />
          <line
            x1="5.74"
            y1="-8"
            x2="5.74"
            y2="-8.5"
            stroke={lineColor}
            strokeWidth="0.2"
          />

          <line
            x1="15.74"
            y1="8"
            x2="15.74"
            y2="8.5"
            stroke={lineColor}
            strokeWidth="0.2"
          />
          <line
            x1="12.8"
            y1="8"
            x2="12.8"
            y2="8.5"
            stroke={lineColor}
            strokeWidth="0.2"
          />
          <line
            x1="10"
            y1="8"
            x2="10"
            y2="8.5"
            stroke={lineColor}
            strokeWidth="0.2"
          />
          <rect x="8.66" y="8  " width="1.31" height="0.5" fill={lineColor} />
          <line
            x1="5.74"
            y1="8"
            x2="5.74"
            y2="8.5"
            stroke={lineColor}
            strokeWidth="0.2"
          />

          <line
            x1="76.12"
            y1="-8"
            x2="76.12"
            y2="-8.5"
            stroke={lineColor}
            strokeWidth="0.2"
          />
          <line
            x1="79.06"
            y1="-8"
            x2="79.06"
            y2="-8.5"
            stroke={lineColor}
            strokeWidth="0.2"
          />
          <rect x="81.89" y="-8.5" width="1.31" height="0.5" fill={lineColor} />
          <line
            x1="86.12"
            y1="-8"
            x2="86.12"
            y2="-8.5"
            stroke={lineColor}
            strokeWidth="0.2"
          />

          <line
            x1="76.12"
            y1="8"
            x2="76.12"
            y2="8.5"
            stroke={lineColor}
            strokeWidth="0.2"
          />
          <line
            x1="79.06"
            y1="8"
            x2="79.06"
            y2="8.5"
            stroke={lineColor}
            strokeWidth="0.2"
          />
          <rect x="81.89" y="8" width="1.31" height="0.5" fill={lineColor} />
          <line
            x1="86.12"
            y1="8"
            x2="86.12"
            y2="8.5"
            stroke={lineColor}
            strokeWidth="0.2"
          />
        </g>
      )}
    </>
  );
}
